export default (err) => {
  if (err.graphQLErrors[0].message && !err.graphQLErrors[0].message.includes('=')) {
    return err.graphQLErrors[0].message
  }
  return 'Ocorreu um erro ao processar sua solicitação.'
}
